import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratKelahiran = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: "",
		agama: "",
		alamat: "",
		alamat_kk: "",
		// detail: [],
		id_jenis: "",
		jenis_kelamin: "",
		kewarganegaraan: "Indonesia",
		kk: "",
		nama_pemohon: "",
		nik: "",
		nik_pelapor: "",
		pekerjaan: "",
		pendidikan_terakhir: "",
		status_perkawinan: "",
		tanggal_lahir: "",
		tempat_lahir: "",
		tujuan_pembuatan: "",

		//detail
        nik_ayah: "",
		nama_ayah: "",
		tempat_lahir_ayah: "",
		tanggal_lahir_ayah: null,
		alamat_ayah: "",
		alamat_kk_ayah: "",
		pekerjaan_ayah: "",

        nik_ibu: "",
        nama_ibu: "",
        tempat_lahir_ibu: "",
        tanggal_lahir_ibu: null,
        alamat_ibu: "",
        alamat_kk_ibu: "",
        pekerjaan_ibu: null,
	};

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmNik3: optionData.frmNik3,
		frmShdk: optionData.frmShdk,
		frmPkr: optionData.frmPkr,
		// frmAgm: optionData.frmAgm,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk2: optionData.tmplistPenduduk2,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		// frmShdk: optionData.frmShdk,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		// detail: [],
		status: {
			form: false,
			btnForm: false,
			dataPenduduk: optionData.status.dataPenduduk,
			dataPenduduk2: optionData.status.dataPenduduk2,
			dataPenduduk3: optionData.status.dataPenduduk3,
			btnAksi: [],
			frmPreviewDraft: false,
		},
		formAyah: 'none',
		formIbu: 'none',
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
        // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		console.log(data);
		console.log(optionData);

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			frmNik: optionData.frmNik,
			frmNik2: optionData.frmNik2,
			frmNik3: optionData.frmNik3,
			frmShdk: optionData.frmShdk,
			frmPkr: optionData.frmPkr,
			// frmAgm: optionData.frmAgm,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			nik3Stat: optionData.nik3Stat,
			status: optionData.status,
			formAyah: optionData.formAyah,
			formIbu: optionData.formIbu,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false || e && fld == "nik2" || e && fld == "nik3") {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;
					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							tmplistPenduduk2: tmplistPenduduk,
							nik2Stat: nikStat
						})
						break;
					case "nik3":
						setFormData({
							...formData,
							frmNik3: frmNik,
							tmplistPenduduk3: tmplistPenduduk,
							nik3Stat: nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel) => {
		setDt({
			...dt,
			[sel]: e,
		})
	}

	const dataAyah = () => {
		let dataPenduduk2 = "block"

		let formAyah = formData.formAyah === "" ? "none" : "";

		if (formAyah !== "") {
			dataPenduduk2 = "none"
		}

		setDt({
			...dt,
			nama_ayah: "",
			tempat_lahir_ayah: "",
			tanggal_lahir_ayah: null,
			pekerjaan_ayah: null,
			nik_ayah: "",
			alamat_ayah: "",
			alamat_kk_ayah: "",
		})
		setFormData({
			...formData,
			status: {
				...formData.status,
				dataPenduduk2
			},
			formAyah,
			nik2Stat: null
		})
	}

	const dataIbu = () => {
		let dataPenduduk3 = "block"

		let formIbu = formData.formIbu === "" ? "none" : "";

		if (formIbu !== "") {
			dataPenduduk3 = "none"
		}

		setDt({
			...dt,
			nama_ibu: "",
			tempat_lahir_ibu: "",
			tanggal_lahir_ibu: null,
			pekerjaan_ibu: null,
			nik_ibu: "",
			alamat_ibu: "",
			alamat_kk_ibu: "",
		})
		setFormData({
			...formData,
			status: {
				...formData.status,
				dataPenduduk3
			},
			formIbu,
			nik3Stat: null
		})
	}

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		if (typeof date._isValid !== 'undefined') {
			let newVal = ''
			if (fld == "tanggal_lahir_anak") {
				newVal = new Date(date.format('YYYY-MM-DD HH:mm:ss'))
			} else {
				newVal = new Date(date.format('YYYY-MM-DD'))
			}
			setDt({
				...dt,
				[fld]: newVal
			})
		}
	}

	const getPenduduk = (e, jns) => {
		if (e) {
			
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

			Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
                
                    if(data.results.data_kk){
                      alamat_kk = data.results.data_kk.alamat
                    }

                    if (jns === "nik") {
                        setDt({
                            ...dt,
                            nik: data.results.id,
                            nik_pelapor: data.results.id,
                            kk: data.results.id_kk,
                            nama: data.results.nama,
                            nama_pemohon: data.results.nama,
                            tempat_lahir: data.results.tempat_lahir,
                            tanggal_lahir: data.results.tanggal_lahir,
                            pekerjaan: data.results.data_pekerjaan.nama,
                            jenis_kelamin: data.results.jk,
                            pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                            agama: data.results.data_agama.nama,
                            status_perkawinan: data.results.status_perkawinan,
                            alamat: alamat,
                            alamat_kk: alamat_kk,
                        })
                        setFormData({
                            ...formData,
                            nikStat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk: "block"
                            },
                        })
                    } else if (jns === "nik2") {
                        setFormData({
                            ...formData,
                            nik2Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk2: "block",
                            },
                        })
                        setDt({
                            ...dt,
                            nik_ayah: data.results.id,
                            nama_ayah: data.results.nama,
                            tempat_lahir_ayah: data.results.tempat_lahir,
                            tanggal_lahir_ayah: data.results.tanggal_lahir,
                            pekerjaan_ayah: {
                                value: data.results.data_pekerjaan.nama,
                                label: data.results.data_pekerjaan.nama,
                            },
                            alamat_ayah: alamat,
                            alamat_kk_ayah: alamat_kk,
                        })
                    } else if (jns === "nik3") {
                        setFormData({
                            ...formData,
                            nik3Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk3: "block",
                            },
                        })
                        setDt({
                            ...dt,
                            nik_ibu: data.results.id,
                            nama_ibu: data.results.nama,
                            tempat_lahir_ibu: data.results.tempat_lahir,
                            tanggal_lahir_ibu: data.results.tanggal_lahir,
                            pekerjaan_ibu: {
                                value: data.results.data_pekerjaan.nama,
                                label: data.results.data_pekerjaan.nama,
                            },
                            alamat_ibu: alamat,
                            alamat_kk_ibu: alamat_kk,
                        })
                    }

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
            })
		} else {
			switch (jns) {
				case "nik":
					// setDt(frmDex)
					setDt({
						...dt,
						nik: '',
						nik_pelapor: '',
						kk: '',
						nama: '',
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						jenis_kelamin: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						alamat: '',
						alamat_kk: '',
					})
					setFormData({
						...formData,
						showBio: false,
						status: {
							...formData.status,
							dataPenduduk: "none"
						},
						nikStat: null,
					})
					break;
				case "nik2":
					setDt({
						...dt,
						nik_ayah: '',
						nama_ayah: '',
						tempat_lahir_ayah: '',
						tanggal_lahir_ayah: new Date(),
						pekerjaan_ayah: null,
						alamat_ayah: '',
						alamat_kk_ayah: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk2: "none"
						},
						nik2Stat: null
					})
					break;
				case "nik3":
					setDt({
						...dt,
						nik_ibu: '',
						nama_ibu: '',
						tempat_lahir_ibu: '',
						tanggal_lahir_ibu: new Date(),
						pekerjaan_ibu: null,
						alamat_ibu: '',
						alamat_kk_ibu: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk3: "none"
						},
						nik3Stat: null
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
          props.setLoadingPreview(true)
        }
        else{
          setAlert({
            loadingPreview: true
          })
        }

		let validasiPemohon = false;
		let validasiAyah = false;
		let validasiIbu = false;

		// validasi pemohon
		if (formData.nikStat != null && dt.hubungan_pelapor) {
			validasiPemohon = true;
		}

		// validasi ayah
		// Input manual data ayah
		if (formData.formAyah !== "none") {
			if (dt.nik_ayah !== '' && dt.pekerjaan_ayah) {
				validasiAyah = true;
			}
		} else { // data ayah otomatis
			if (formData.nik2Stat) {
				validasiAyah = true;
			}
		}

		// validasi ibu
		// Input manual data ibu
		if (formData.formIbu !== "none") {
			if (dt.nik_ibu !== '' && dt.pekerjaan_ibu) {
				validasiIbu = true;
			}
		} else { // data ibu otomatis
			if (formData.nik3Stat) {
				validasiIbu = true;
			}
		}

		console.log(validasiPemohon);
		console.log(validasiAyah);
		console.log(validasiIbu);
		console.log(dt.jk_anak);

		if (validasiPemohon && validasiAyah && validasiIbu && dt.jk_anak !== null) {
			let tanggal_lahir = new Date(dt.tanggal_lahir);
			let tanggal_lahir_ayah = new Date(dt.tanggal_lahir_ayah);
			let tanggal_lahir_ibu = new Date(dt.tanggal_lahir_ibu);
			let tanggal_lahir_anak = ''
            if(dt.tanggal_lahir_anak === undefined){
                tanggal_lahir_anak = new Date()
            }
            else{
                tanggal_lahir_anak = new Date(dt.tanggal_lahir_anak);
            }   

			let bodyRaw = {
				...dt,
				tanggal_lahir_pelapor: dateFormat(tanggal_lahir, 'yyyy-mm-dd'),
				tanggal_lahir_ayah: dateFormat(tanggal_lahir_ayah, 'yyyy-mm-dd'),
				tanggal_lahir_ibu: dateFormat(tanggal_lahir_ibu, 'yyyy-mm-dd'),
				pekerjaan_ayah: dt.pekerjaan_ayah.label,
				pekerjaan_ibu: dt.pekerjaan_ibu.label,

				nik_pelapor: dt.nik,
                nama_pelapor: dt.nama,
                tempat_lahir_pelapor: dt.tempat_lahir,
                jenis_kelamin_pelapor: dt.jenis_kelamin,
                pekerjaan_pelapor: dt.pekerjaan,
                agama_pelapor: dt.agama,
                alamat_pelapor: dt.alamat,
                alamat_kk_pelapor: dt.alamat_kk,
				hubungan_pelapor: dt.hubungan_pelapor.label,

				jk_anak: dt.jk_anak.label,
				tanggal_lahir_anak: dateFormat(tanggal_lahir_anak, 'yyyy-mm-dd HH:MM:ss'),
			};
			delete bodyRaw.nik
			delete bodyRaw.nama
			delete bodyRaw.tempat_lahir
			delete bodyRaw.jenis_kelamin
			delete bodyRaw.pekerjaan
			delete bodyRaw.agama
			delete bodyRaw.alamat
			delete bodyRaw.status_perkawinan
			console.log(bodyRaw);

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			Post(
				"surat-keterangan/kelahiran/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					// Kalau mode kiosk
					if (kioskMode) {
						if (res.status === resstat) {
                            let dataAntrian = {
                                nama: props.data.results.nama,
                                nik: props.data.results.id,
                                keterangan: '',
                                uuid_surat:res.data.results.uuid_surat,
                                kode_surat:res.data.results.kode_surat,
                            };
                    
                            // Set Data Surat
                            props.getDataSurat(res.data.results);

                            setTimeout(function () {
                                Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
                                    
                                    props.setLoadingPreview(false)

                                    if (res2.code === 201) {
                                        props.getAntrian('Surat Keterangan Kelahiran', 'berhasil', false, dataAntrian);
                                    }
                                    else {
                                        props.getAntrian('Surat Keterangan Kelahiran', 'gagal');
                                    }
                                });
                            }.bind(this),1000)
                        }
                        else{
                            props.setLoadingPreview(false)
                            props.getAntrian('Surat Keterangan Kelahiran', 'gagal');
                        }

					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
							const alertData = {
                                get_data_surat:{
                                  uuid_surat:res.data.results.uuid_surat,
                                  kode_surat:res.data.results.kode_surat,
                                },
                                status:{
                                  frmPreviewDraft: true,
                                  jenis_form: psn,
                                }
                                // show: true,
                                // basicType: "success",
                                // basicTitle: "Data Surat Keterangan Kelahiran",
                                // pesanAlert: "Berhasil " + psn + " Data",
                                // successAlert: true
                            };
                            setAlert({
                                loadingPreview: false
                            })
                            setAlert(alertData);
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Kelahiran",
								pesanAlert: "Gagal " + psn + " Data"
							}
                            setAlert({
                                loadingPreview: false
                            })
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}
				}
			);

		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Kelahiran', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
                setAlert({
                    loadingPreview: false
                })
				setAlert(alertData)
			}
		}

	};

	return (
		<Modal
            open={isOpen}
            onClose={() => {
                setIsOpen(false);
            }}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            style={{
                maxwidth: "unset"
            }}
            styles={{
                modal: {
                    width: '100%',
                    // minWidth: '301px'
                }
            }}
        >
            <Form data-testid="form-create" className="theme-form" onSubmit={simpan} style={{ maxwidth: "unset", width: '100%',}}>
                <div className="modal-header">
                    <h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Kelahiran</h5>
                </div>
                <div className="modal-body">
                    <input
                        className="form-control"
                        id="uuid"
                        type="hidden"
                        placeholder=""
                        defaultValue={dt.uuid}
                    />

                    {/* Data Anak */}
                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Detail Data Anak</b>
                    </div>
                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="inputEmail3"
                        >
                            Nama Anak
                        </Label>
                        <Col sm="9">
                            <input
                                data-testid="nama anak"
                                name="nama_anak"
                                className="form-control"
                                id="nama_anak"
                                type="text"
                                required
                                placeholder="Contoh : Muhammad Zayn"
                                defaultValue={dt.nama_anak}
                                value={dt.nama_anak}
                                onChange={e => changeInputText(e, "nama_anak")}
                                onFocus={e => e.currentTarget.select()}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="inputEmail3"
                        >
                            Tempat Lahir Anak
                        </Label>
                        <Col sm="9">
                            <input
                                data-testid="tempat lahir anak"
                                name="tempat_lahir_anak"
                                className="form-control"
                                id="tempat_lahir_anak"
                                type="text"
                                required
                                placeholder="Contoh : Jakarta"
                                defaultValue={dt.tempat_lahir_anak}
                                value={dt.tempat_lahir_anak}
                                onChange={e => changeInputText(e, "tempat_lahir_anak")}
                                onFocus={e => e.currentTarget.select()}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="tanggal_lahir_anak"
                        >
                            Tanggal Lahir Anak
                        </Label>
                        <Col sm="9">
                            <Datetime
                                inputProps={{ "data-testid": "tanggal_lahir_anak", placeholder: 'Tanggal Lahir Anak', required: true }}
                                inputId="tanggal_lahir_anak"
                                name="tanggal_lahir_anak"
                                locale="id-ID"
                                timeFormat="HH:mm"
                                dateFormat="DD/MM/yyyy"
                                input={true}
                                closeOnTab={true}
                                initialValue={dt.tanggal_lahir_anak}
                                value={dt.tanggal_lahir_anak}
                                onChange={e => {
                                    gantiTgl(e, "tanggal_lahir_anak");
                                }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="inputEmail3"
                        >
                            Jenis Kelamin Anak
                        </Label>
                        <Col sm="9">
                            <div data-testid="selectJenisKelaminAnak">
                                <Select
                                    inputId="jk_anak"
                                    classNamePrefix="select"
                                    onChange={e => {
                                        changeSelectValue(e, "jk_anak");
                                    }}
                                    value={dt.jk_anak}
                                    name="jk_anak"
                                    options={[
                                        {
                                            value: "Laki-Laki",
                                            label: "Laki-Laki",
                                        },
                                        {
                                            value: "Perempuan",
                                            label: "Perempuan",
                                        },
                                    ]}
                                    placeholder="Pilih Jenis Kelamin Anak"
                                />
                            </div>
                        </Col>
                    </FormGroup>

                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Data Ayah</b>
                    </div>
                    <FormGroup className="row mb-1">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="nik2"
                        >
                            NIK Ayah
                        </Label>
                        <Col sm="9">
                            {formData.formAyah === "none" ? (
                                <div data-testid="selectNIK2">
                                    <Select
                                        inputId="nik2"
                                        isDisabled={formData.status.select}
                                        classNamePrefix="select"
                                        onChange={e => {
                                            getPenduduk(e, "nik2");
                                        }}
                                        defaultValue={formData.nik2Stat}
                                        value={formData.nik2Stat}
                                        name="penduduk"
                                        onInputChange={e => handleInputChangeNIK(e, "nik2")}
                                        options={formData.frmNik2}
                                        placeholder="Pilih NIK Ayah"
                                        isClearable
                                    />
                                </div>
                            ) : (
                                <></>
                            )}
                            <input
                                data-testid="nik_ayah"
                                name="nik_ayah"
                                className="form-control"
                                id="nik_ayah"
                                type={formData.formAyah === "none" ? "hidden" : "text"}
                                pattern="\d{1,16}"
                                maxLength={16}
                                minLength={16}
                                required
                                placeholder="Masukkan NIK Ayah (16 angka)"
                                defaultValue={dt.nik_ayah}
                                value={dt.nik_ayah}
                                onChange={e => changeInputText(e, "nik_ayah")}
                            />
                            <small id="emailHelp" className="form-text text-muted">
                                Data NIK {formData.formAyah === "none" ? "tidak" : ""}{" "}
                                tersedia?{" "}
                                <span
                                    style={{ cursor: "pointer", color: "#0000ff" }}
                                    onClick={() => {
                                        if (formData.formAyah === "none") {
                                            if (props.getJenisInput) {
                                                props.getJenisInput("manual")
                                            }
                                        }
                                        else {
                                            if (props.getJenisInput) {
                                                props.getJenisInput("auto")
                                            }
                                        }
                                        dataAyah()
                                    }}
                                >
                                    Klik disini
                                </span>
                            </small>
                        </Col>
                    </FormGroup>
                    <div
                        style={{ display: formData.status.dataPenduduk2 }}
                    >
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Nama Ayah
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="nama_ayah"
                                    name="nama_ayah"
                                    className="form-control"
                                    id="nama_ayah"
                                    type="text"
                                    required
                                    readOnly={formData.formAyah === "" ? false : true}
                                    placeholder="Contoh : Toni"
                                    defaultValue={dt.nama_ayah}
                                    value={dt.nama_ayah}
                                    onChange={e => changeInputText(e, "nama_ayah")}

                                    style={formData.formAyah === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formAyah === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tempat Lahir Ayah
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="tempat_lahir_ayah"
                                    name="tempat_lahir_ayah"
                                    className="form-control"
                                    id="tempat_lahir_ayah"
                                    type="text"
                                    required
                                    readOnly={formData.formAyah === "" ? false : true}
                                    placeholder="Contoh : Jakarta"
                                    defaultValue={dt.tempat_lahir_ayah}
                                    value={dt.tempat_lahir_ayah}
                                    onChange={e =>
                                        changeInputText(e, "tempat_lahir_ayah")
                                    }

                                    style={formData.formAyah === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formAyah === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tanggal Lahir Ayah
                            </Label>
                            <Col sm="9">
                                {
                                    formData.formAyah === ""
                                        ?
                                        <Datetime
                                            inputProps={{ "data-testid": "tanggal_lahir_ayah", placeholder: 'Klik disini untuk memilih tanggal', required: true }}
                                            // data-testid="tanggal_lahir_ayah"
                                            inputId="tanggal_lahir_ayah"
                                            name="tanggal_lahir_ayah"
                                            locale="id-ID"
                                            input={true}
                                            timeFormat={false}
                                            closeOnTab={true}
                                            closeOnSelect={true}
                                            // dateFormat="yyyy-MM-DD"
                                            dateFormat="DD/MM/yyyy"
                                            initialValue={dt.tanggal_lahir_ayah}
                                            value={dt.tanggal_lahir_ayah}
                                            onChange={(e) => {
                                                gantiTgl(e, 'tanggal_lahir_ayah');
                                            }}
                                        />
                                        :
                                        <input
                                            className="form-control"
                                            id="tanggal_lahir_ayah"
                                            type="text"
                                            readOnly
                                            placeholder="Tanggal Lahir"
                                            value={dt.tanggal_lahir_ayah}
                                            defaultValue={dt.tanggal_lahir_ayah}
                                            style={formData.formAyah === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                            disabled={formData.formAyah === "" ? false : true}
                                        />
                                }

                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Pekerjaan Ayah
                            </Label>
                            <Col sm="9">
                                {formData.formAyah === "" ? (
                                    <div data-testid="selectPekerjaan">
                                        <Select
                                            inputId="pekerjaan_ayah"
                                            classNamePrefix="select"
                                            onChange={e => {
                                                changeSelectValue(e, "pekerjaan_ayah");
                                            }}
                                            value={dt.pekerjaan_ayah}
                                            name="pekerjaan_ayah"
                                            options={formData.frmPkr}
                                            placeholder="Pilih Pekerjaan Ayah"
                                            isClearable
                                        />
                                    </div>
                                ) : (
                                    <input
                                        id="pekerjaan_ayah"
                                        type="text"
                                        className="form-control"
                                        readOnly
                                        value={dt.pekerjaan_ayah ? dt.pekerjaan_ayah.label : ''}
                                        style={{ backgroundColor: "#c9d1d8" }}
                                    />
                                )
                                }
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Alamat Ayah
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="alamat_kk_ayah"
                                    name="alamat_kk_ayah"
                                    className="form-control"
                                    id="alamat_kk_ayah"
                                    type="text"
                                    readOnly={formData.formAyah === "" ? false : true}
                                    required
                                    placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
                                    defaultValue={dt.alamat_kk_ayah}
                                    value={dt.alamat_kk_ayah}
                                    onChange={e => changeInputText(e, "alamat_kk_ayah")}

                                    style={formData.formAyah === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formAyah === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                Wilayah
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    id="alamat_ayah"
                                    type="text"
                                    readOnly={formData.formAyah === "" ? false : true}
                                    required
                                    defaultValue={dt.alamat_ayah}
                                    value={dt.alamat_ayah}
                                    onChange={e => changeInputText(e, "alamat_ayah")}
                                    style={formData.formAyah === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formAyah === "" ? false : true}
                                />
                                {
                                    formData.formAyah === ""
                                    ?
                                        <small><font color="red">* Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau</font></small>
                                    :
                                        <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                }
                            </Col>
                        </FormGroup>
                    </div>

                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Data Ibu</b>
                    </div>
                    {/* Form Ibu */}
                    <FormGroup className="row mb-1">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="nik2"
                        >
                            NIK Ibu
                        </Label>
                        <Col sm="9">
                            {formData.formIbu === "none" ? (
                                <div data-testid="selectNIK3">
                                    <Select
                                        inputId="nik3"
                                        isDisabled={formData.status.select}
                                        classNamePrefix="select"
                                        onChange={e => {
                                            getPenduduk(e, "nik3");
                                        }}
                                        defaultValue={formData.nik3Stat}
                                        value={formData.nik3Stat}
                                        name="penduduk"
                                        onInputChange={e => handleInputChangeNIK(e, "nik3")}
                                        options={formData.frmNik3}
                                        placeholder="Pilih NIK Ibu"
                                        isClearable
                                    />
                                </div>
                            ) : ''}
                            <input
                                data-testid="nik_ibu"
                                name="nik_ibu"
                                className="form-control"
                                id="nik_ibu"
                                type={formData.formIbu === "none" ? "hidden" : "text"}
                                pattern="\d{1,16}"
                                maxLength={16}
                                minLength={16}
                                required
                                placeholder="Masukkan NIK Ibu (16 angka)"
                                defaultValue={dt.nik_ibu}
                                value={dt.nik_ibu}
                                onChange={e => changeInputText(e, "nik_ibu")}
                            />
                            <small id="emailHelp" className="form-text text-muted">
                                Data NIK {formData.formIbu === "none" ? "tidak" : ""}{" "}
                                tersedia?{" "}
                                <span
                                    style={{ cursor: "pointer", color: "#0000ff" }}
                                    onClick={() => {
                                        if (formData.formIbu === "none") {
                                            if (props.getJenisInput) {
                                                props.getJenisInput("manual")
                                            }
                                        }
                                        else {
                                            if (props.getJenisInput) {
                                                props.getJenisInput("auto")
                                            }
                                        }
                                        dataIbu()
                                    }}
                                >
                                    Klik disini
                                </span>
                            </small>
                        </Col>
                    </FormGroup>
                    <div
                        style={{ display: formData.status.dataPenduduk3 }}
                    >
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Nama Ibu
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="nama_ibu"
                                    name="nama_ibu"
                                    className="form-control"
                                    id="nama_ibu"
                                    type="text"
                                    required
                                    readOnly={formData.formIbu === "" ? false : true}
                                    placeholder="Contoh : Sri Mustika"
                                    defaultValue={dt.nama_ibu}
                                    value={dt.nama_ibu}
                                    onChange={e => changeInputText(e, "nama_ibu")}

                                    style={formData.formIbu === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formIbu === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tempat Lahir Ibu
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="tempat_lahir_ibu"
                                    name="tempat_lahir_ibu"
                                    className="form-control"
                                    id="tempat_lahir_ibu"
                                    type="text"
                                    required
                                    readOnly={formData.formIbu === "" ? false : true}
                                    placeholder="Contoh : Jakarta"
                                    defaultValue={dt.tempat_lahir_ibu}
                                    value={dt.tempat_lahir_ibu}
                                    onChange={e =>
                                        changeInputText(e, "tempat_lahir_ibu")
                                    }

                                    style={formData.formIbu === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formIbu === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tanggal Lahir Ibu
                            </Label>
                            <Col sm="9">
                                {
                                    formData.formIbu === ""
                                        ?
                                        <Datetime
                                            inputProps={{ "data-testid": "tanggal_lahir_ibu", placeholder: 'Klik disini untuk memilih tanggal', required: true }}
                                            // data-testid="tanggal_lahir_ibu"
                                            inputId="tanggal_lahir_ibu"
                                            name="tanggal_lahir_ibu"
                                            locale="id-ID"
                                            input={true}
                                            timeFormat={false}
                                            closeOnTab={true}
                                            closeOnSelect={true}
                                            // dateFormat="yyyy-MM-DD"
                                            dateFormat="DD/MM/yyyy"
                                            initialValue={dt.tanggal_lahir_ibu}
                                            value={dt.tanggal_lahir_ibu}
                                            onChange={(e) => {
                                                gantiTgl(e, 'tanggal_lahir_ibu');
                                            }}
                                        />
                                        :
                                        <input
                                            className="form-control"
                                            id="tanggal_lahir_ibu"
                                            type="text"
                                            readOnly
                                            placeholder="Tanggal Lahir"
                                            value={dt.tanggal_lahir_ibu}
                                            defaultValue={dt.tanggal_lahir_ibu}
                                            style={formData.formIbu === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                            disabled={formData.formIbu === "" ? false : true}
                                        />
                                }
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Pekerjaan Ibu
                            </Label>
                            <Col sm="9">
                                {formData.formIbu === "" ? (
                                    <div data-testid="selectPekerjaan">
                                        <Select
                                            inputId="pekerjaan_ibu"
                                            classNamePrefix="select"
                                            onChange={e => {
                                                changeSelectValue(e, "pekerjaan_ibu");
                                            }}
                                            value={dt.pekerjaan_ibu}
                                            name="pekerjaan_ibu"
                                            options={formData.frmPkr}
                                            placeholder="Pilih Pekerjaan Ibu"
                                            isClearable
                                        />
                                    </div>
                                ) : (
                                    <input
                                        id="pekerjaan_ibu"
                                        type="text"
                                        className="form-control"
                                        readOnly
                                        value={dt.pekerjaan_ibu ? dt.pekerjaan_ibu.label : ''}
                                        style={{ backgroundColor: "#c9d1d8" }}
                                    />
                                )
                                }
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Alamat Ibu
                            </Label>
                            <Col sm="9">
                                <input
                                    data-testid="alamat_kk_ibu"
                                    name="alamat_kk_ibu"
                                    className="form-control"
                                    id="alamat_kk_ibu"
                                    type="text"
                                    readOnly={formData.formIbu === "" ? false : true}
                                    required
                                    placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
                                    defaultValue={dt.alamat_kk_ibu}
                                    value={dt.alamat_kk_ibu}
                                    onChange={e => changeInputText(e, "alamat_kk_ibu")}

                                    style={formData.formIbu === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formIbu === "" ? false : true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                Wilayah
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    id="alamat_ibu"
                                    type="text"
                                    readOnly={formData.formIbu === "" ? false : true}
                                    required
                                    defaultValue={dt.alamat_ibu}
                                    value={dt.alamat_ibu}
                                    onChange={e => changeInputText(e, "alamat_ibu")}
                                    style={formData.formIbu === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
                                    disabled={formData.formIbu === "" ? false : true}
                                />
                                {
                                    formData.formIbu === ""
                                    ?
                                        <small><font color="red">* Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau</font></small>
                                    :
                                        <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                }
                            </Col>
                        </FormGroup>
                    </div>
                    <hr />


                    <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                        <b>Data Pemohon</b>
                    </div>
                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="nik"
                        >
                            NIK Pemohon
                        </Label>
                        <Col sm="9">
                            <div data-testid="selectNIK">
                                <Select
                                    inputId="nik"
                                    classNamePrefix="select"
                                    onChange={e => {
                                        getPenduduk(e, "nik");
                                    }}
                                    defaultValue={formData.nikStat}
                                    value={formData.nikStat}
                                    name="penduduk"
                                    onInputChange={e => handleInputChangeNIK(e, "nik")}
                                    options={formData.frmNik}
                                    placeholder="Pilih NIK Pemohon"
                                    isClearable
                                />
                            </div>
                        </Col>
                    </FormGroup>

                    <div
                        style={{ display: formData.status.dataPenduduk }}
                    >
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Nama Pemohon
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    id="nama_pemohon"
                                    readOnly
                                    type="text"
                                    placeholder="nama_pemohon"
                                    value={dt.nama_pemohon}
                                    style={{ backgroundColor: "#c9d1d8" }}
                                    disabled
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tempat Lahir
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    readOnly
                                    id="tempat_lahir"
                                    type="text"
                                    placeholder="Tempat lahir"
                                    value={dt.tempat_lahir}
                                    style={{ backgroundColor: "#c9d1d8" }}
                                    disabled
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Tanggal Lahir
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    id="tanggal_lahir"
                                    readOnly
                                    type="text"
                                    placeholder="Tanggal Lahir"
                                    value={dt.tanggal_lahir}
                                    style={{ backgroundColor: "#c9d1d8" }}
                                    disabled
                                />
                            </Col>
                        </FormGroup>
                        {/* <FormGroup className="row">
                            <Label
                                className="col-sm-3 col-form-label"
                                htmlFor="inputEmail3"
                            >
                                Status Perkawinan
                            </Label>
                            <Col sm="9">
                                <input
                                    className="form-control"
                                    id="status_perkawinan"
                                    type="text"
                                    readOnly
                                    placeholder="Status Perkawinan"
                                    value={dt.status_perkawinan}

                                    style={{ backgroundColor: "#c9d1d8" }}
                                    disabled
                                />
                            </Col>
                        </FormGroup> */}
                    </div>

                    <FormGroup className="row">
                        <Label
                            className="col-sm-3 col-form-label"
                            htmlFor="shdk"
                        >
                            Hubungan Pemohon
                        </Label>
                        <Col sm="9">
                            <div data-testid="selectShdk">
                                <Select
                                    inputId="shdk"
                                    classNamePrefix="select"
                                    onChange={e => {
                                        changeSelectValue(e, "hubungan_pelapor");
                                    }}
                                    defaultValue={dt.hubungan_pelapor}
                                    value={dt.hubungan_pelapor}
                                    id="shdk"
                                    options={formData.frmShdk}
                                    placeholder="Hubungan Pemohon dengan Anak"
                                />
                            </div>
                        </Col>
                    </FormGroup>

                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => {
                            // Tutup modal
                            setFormData({
                                ...formData,
                                status: {
                                    ...formData.status,
                                    form: false
                                }
                            })
                            setIsOpen(false)
                        }}
                    >
                        Tutup
                    </button>
                    <button
                        data-testid="btnSubmitCreate"
                        type="submit"
                        className="btn btn-primary-custom"
                    // disabled={formData.status.btnForm}
                    >
                        Simpan
                    </button>
                </div>
			</Form>
		</Modal>
	);
}

export default ModalSuratKelahiran;
